import ProductWithTextCard, { ProductWithTextCardProps } from './ProductWithTextCard'
export default ProductWithTextCard
export { ProductWithTextCard }
export type { ProductWithTextCardProps }
